import { Button, Text, Title, YStack } from '@frontend/web-react';

type SecureNoteTypeSelectionProps = {
  onSelectManual: () => void;
  onSelectSecureSession: () => void;
  title: string;
};

export const SecureNoteTypeSelection = ({
  onSelectManual,
  onSelectSecureSession,
  title,
}: SecureNoteTypeSelectionProps) => {
  return (
    <YStack className="gap-y-lg py-md">
      <Title textAlign="center" type="h4">
        {title}
      </Title>
      <YStack className="gap-y-md">
        <Text type="p-md">This domain typically requires 2-step verification. You have two options:</Text>
        <ol style={{ paddingLeft: '1.5rem' }}>
          <li style={{ marginBottom: '0.5rem' }}>
            <Text type="p-md">
              <strong>Secure Session (Beta)</strong> - Log in safely right here, no code sharing needed. This will open
              a secure browser session where you can login to your account and complete 2FA as you normally would.
            </Text>
          </li>
          <li>
            <Text type="p-md">
              <strong>Manual 2FA</strong> - Schedule a moment with us to log in together and share the verification
              code.
            </Text>
          </li>
        </ol>
        <Text style={{ color: 'var(--mantine-color-gray-6)' }} type="p-sm">
          Secure Live View is in beta and may not work for all sites or devices. If it doesn&apos;t, you can always
          switch back to the manual option.
        </Text>
      </YStack>
      <YStack className="gap-y-sm">
        <Button label="Launch Secure Session" onClick={onSelectSecureSession} variant="primary" />
        <Button label="Handle it Manually" onClick={onSelectManual} variant="secondary" />
      </YStack>
    </YStack>
  );
};
